import { userShape } from "../../shapes";

type Props = {
  user?: userShape;
  actions?: React.ReactNode;
  showUserEmail?: boolean;
};

function UserItem({ user, actions, showUserEmail }: Props) {
  // @ts-expect-error TS(2339) FIXME: Property 'first_name' does not exist on type 'user... Remove this comment to see the full error message
  const { first_name: firstName, last_name: lastName, email } = user;
  const name = `${firstName || ""} ${lastName || ""}`.trim();

  const showName = () => {
    const regex = /@connect$/;
    if (regex.test(email)) {
      return email;
    }

    return name || "No name";
  };

  return (
    <li className="list-item">
      <div className="list-item-image">
        <span className="icon lcm-iot-icon-user" />
      </div>
      <div className="list-item-header-only">
        {showName()}
        {showUserEmail && (
          <>
            <br />
            <span className="list-item-header-email">{email}</span>
          </>
        )}
      </div>
      {actions && <div className="list-item-actions">{actions}</div>}
    </li>
  );
}

export default UserItem;
